/*
 * SashiDo
 * All rights reserved.
 */

import Button             from 'components/Button/Button.react';
import ChromeDropdown     from 'components/ChromeDropdown/ChromeDropdown.react';
import Field              from 'components/Field/Field.react';
import styles             from 'components/Modal/Modal.scss';
import Label              from 'components/Label/Label.react';
import Modal              from 'components/Modal/Modal.react';
import React              from 'react';
import { DataTypes }      from 'lib/Constants';
import TextInput          from 'components/TextInput/TextInput.react';

export default class PushAudienceEveryoneDialog extends React.Component {
  constructor(props) {
    super();
    this.state = {}

    this.handleKey = this.handleKey.bind(this);
    this.onCloseClick = this.onCloseClick.bind(this);
  }

  componentDidMount(){
    document.body.addEventListener('keydown', this.handleKey);
  }

  componentWillUnmount() {
    document.body.removeEventListener('keydown', this.handleKey);
  }

  onCloseClick() {
    this.props.onCancel();
  }

  handleKey(e) {
    var keyCode = e.keyCode || e.which;
    switch (keyCode) {
      case 27:
        this.onCloseClick(this);
        break;
    }
  }

  render() {
    return (
      <Modal
        type={Modal.Types.DANGER}
        title='Send to Everyone?'
        subtitle={'Be careful, this action cannot be undone!'}
        confirmText='Send Push'
        cancelText={'Cancel'}
        onCancel={this.onCloseClick.bind(this)}
        onConfirm={() => {
          this.props.onConfirm();
        }}
        >
        <p className={styles.only}>Are you sure that you want to send this <strong>Push Notification</strong> to <strong>Everyone</strong>?</p>
      </Modal>
    );
  }
}
